import { GET_BANNER_REQUEST, GET_BANNER_SUCCESS, GET_BANNER_FAILED } from '../types';

import { combineReducers } from 'redux';

const IntialState_1 = {
  loading: false,
  status: null,
  message: null,
  response: [],
  isError: false,
};

const banner = (state = IntialState_1, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_BANNER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_BANNER_SUCCESS:
      console.log('res.data[0]: ', res.data.data?.[0]);
      return {
        ...state,
        status: res.status,
        response: res.data.data?.[0] || {},
        loading: false,
        isError: false,
      };
    case GET_BANNER_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const combinedDashboad = combineReducers({
  banner,
});
export default combinedDashboad;
